// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as ReceivedActions } from '../duck';
import Received from '../components/Received';
import type { RootState } from "../../../../index";

function mapStateToProps(state: RootState){
  return {
    localValues: state.localValues,
    order: state.order.order,
    isConfirmingArrival: state.order.sale.received.isProgressing,
    motives: state.report.motives,
    locale: state.locale,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators(ReceivedActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Received);



// WEBPACK FOOTER //
// ./src/modules/order/Sale/received/containers/ReceivedContainer.jsx